module.exports = __webpack_public_path__ + "static/img/background.75106d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background.png
// module id = RTs6
// module chunks = 0